import { NativeModules } from 'react-native';

type ArYolopoloType = {
  multiply(a: number, b: number): Promise<number>;
};

const { ArYolopolo } = NativeModules;

export default ArYolopolo as ArYolopoloType;
